import { message } from "antd";
import axios from "axios";
import { delay } from "lodash";
import { useNavigate, Navigate } from "react-router-dom";

const baseURL = "https://community.warwickwexon.com";

const request = axios.create({
  url: baseURL,
  timeout: 5 * 1000,
  // withCredentials: true,
  // headers: {
  //   'Content-Type': 'multipart/form-data',
  // },
});

//请求拦截，封装fresh_token刷新逻辑
request.interceptors.request.use((config) => {
  //对每个请求都附上身份认证

  if (localStorage.getItem("Authorization")) {
    // config.headers['Authorization'] = localStorage.getItem('Authorization')
    config.headers["Authorization"] = localStorage.getItem("Authorization");
  }
  //将图片上传的类型改为multipart/form-data
  if (config.url.indexOf("/upload/origin") !== -1) {
    config.headers["Content-Type"] = "multipart/form-data";
  }

  // const currentTime = new Date().getTime()
  // const loginTime = localStorage.getItem("last_login")
  // const expireTime = 24*60*60*2

  // console.log((currentTime - loginTime) / 1000, expireTime)

  // if (config.url.indexOf('/login') !== -1) {
  //   return config
  // } else if (config.url.indexOf('')) {
  // }

  return config;
});

request.interceptors.response.use(
  (response) => {
    // console.log(response.data.code)
    if (response.data.code === 1003) {
      //登录过期
      console.log("登录已过期或认证失败");
      message.error("登录已过期，请重新登录！");
      localStorage.clear();
      delay(() => {
      window.location.href = "/login"
      }, 100);
    }
    if (response.data.code === 1006) {
      //权限不足
      window.location.href = "/403";
    }

    if (response.config.url.indexOf("login") !== -1) {
      console.log(response);
    }

    return response;
  },
  (error) => {
    console.log("拦截器error", error);
    //网络超时异常处理
    if (
      error.code === "ECONNABORTED" ||
      error.message === "Network Error" ||
      error.message.includes("timeout")
    ) {
      message.error("请求超时，请稍后重试");
    }
  }
);

export default request;
